<template>
    <div>
        <div class="module-result-content-field">
            <div class="result-content-field">
                <el-table
                        :data="fieldList"
                        width="100%"
                        height="calc(100vh - 135px)"
                        :header-cell-style="{fontSize:'14px', fontWeight:'500'}"
                        :row-style="{fontSize:'14px',cursor:'pointer'}"
                        :row-class-name="getRowClass"
                >
                    <el-table-column
                            type="index"
                            :index="indexMethod"
                            label="序号"
                            width="100"
                            style="margin-left: 50px;"
                            align="center"
                            header-align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="字段名称"
                            align="left"
                            header-align="left"
                            width="100%"
                            style="text-align: left"
                            :show-overflow-tooltip="true"


                    >
                        <template scope="scope">
                            <div class="fieldinfoName">
                                {{scope.row.name}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="字段类型"
                            align="center"
                            header-align="center"
                            width="150"
                            >
                              <template scope="scope">
                                <div>
                                    <span>{{scope.row.type|typeLable}}</span>
                                </div>
                            </template>
                    </el-table-column>

                    <el-table-column
                            prop="description"
                            label="字段描述"
                            align="left"
                            header-align="left"
                            style="text-align: left"
                            :show-overflow-tooltip="true"

                            >
                              <template scope="scope">

                                  <div class="fieldinfoDes" v-if="scope.row.description!==''">{{scope.row.description}}</div>
                                  <div class="fieldinfoDes" v-if="scope.row.description===''">--</div>

                              </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100"
                            align="center"
                            >
                            <template scope="scope">
                    <div class="fieldinfoOperation">
                        <div class="fieldinfoOperationBtn">
                            <div class="fieldInfoRevise">
                                <div class="reviseImg">
                                    <img src="../../../assets/images/fieldmanage/rivese.png" style="height: 16px;width: 16px" @click="reviseField(scope.row.id,scope.row)"/>
                                </div>
                            </div>
                            <div class="fieldInfoDelete">
                                <img src="../../../assets/images/fieldmanage/delBlue.png" style="width: 16px;height: 16px" @click="deleteOpenDialog(scope.row.id)"/>
                            </div>
                        </div>
                    </div>
                </template>
                    </el-table-column>

                </el-table>
            </div>
        </div>

               <!-- <div class="filedinfoNumber">
                    <span>{{index+1}}</span>
                </div>


                <div class="fieldinfoName">
                   {{items.name}}
                </div>

                <div class="fieldinfoAttribute">
                    <span>{{items.type|typeLable}}</span>
                </div>


                <div class="fieldinfoDescription">
                    <div class="fieldinfoDes">{{items.description}}</div>
                </div>
-->


        <el-dialog  :visible.sync="dialogFormVisible1" title="编辑字段" custom-class="fieldinfoDialog" style="text-align: left" :close-on-click-modal="false">

            <div class="filedName">
                <div class="filedNameText"><span class="bixuan">*</span>字段名称</div>
                <el-input
                        v-model=filedName
                        autocomplete="off"
                        placeholder="请输入字段名称"
                        class="filedNameInput"
                        maxlength="10"
                ></el-input>
            </div>
            <div class="filedDescribe">
                <div class="filedDescribeText">字段描述</div>
                <el-input class="filedDescribeInput" v-model='filedDescription' autocomplete="off"  placeholder="请输入字段描述">{{items.fieldAttribute}}</el-input>

            </div>

            <div class="isScreen" v-show="show!==0&&show!==1&&show!==8">
                <div class="isScreenText">是否可筛选</div>
                <div class="isScreenRadio">
                    <el-radio v-model="radio" label="1" @change="change">是</el-radio>
                    <el-radio v-model="radio" label="2" @change="chang2">否</el-radio>
                </div>
            </div>
            <div class="selectFiled">
                <div class="selectFiledText">选择字段类型</div>
                <el-select v-model=fieldType @change="selectType" class="selectFiledSelect">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <!--根据选择的字段类型显示不同的提示-->

            <!--1.选择单行文本-->

            <div class="singleText" v-show="show===0">
                <div class="singleTextInput">
                    <el-input v-model="singleText" autocomplete="off"  placeholder="示例:我的名字是什么"  size="small"></el-input>
                </div>
                <div class="singleTextText">
                    <div class="text" style="margin-right: 8px">可输入少量的文本</div>
                </div>
                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>
            <div class="multiLineText" v-show="show===1">
                <div class="mulInput">
                    <el-input
                            v-model="singleText"
                            placeholder="可以输入大量文本"
                            type="textarea"
                            :rows="2"
                            size="mini"
                    >
                    </el-input>
                </div>
                <div class="text" style="margin-right: 8px">可输入大量的文本</div>
                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>
            <div class="block" v-show="show===2">

                <div class="dataPicker">
                    <el-date-picker
                            class="data"
                            v-model="datePicker"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"

                    >
                    </el-date-picker>
                </div>
                <div class="dataPickerText" style="margin-right: 8px">日期,&nbsp;如:{{value2}}</div>


                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>

            <div class="timeSelect" v-show="show===3">

                <div class="timePicker">
                    <el-time-picker
                            v-model="time1"
                            placeholder="任意时间点"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            style="width: 100%"
                    >
                    </el-time-picker>
                </div>
                <div class="timePickerText" style="margin-right: 8px">时间,&nbsp;如:{{time1}}</div>


                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>

            <div class="fieldSelect" v-show="show===4">
                <div class="selectMore">
                    <el-select v-model="select2" placeholder="请选择" multiple style="width: 100%">
                        <el-option label="选项1" value="选项1"></el-option>
                        <el-option label="选项2" value="选项2"></el-option>
                    </el-select>
                </div>
                <div class="selectMoreText" style="margin-right: 8px">多个选择中选择一个</div>

                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>

            <div class="fieldManRadio" v-show="show===5">

                <div class="radioCheck" style="display: flex">
                    <div style="flex: 0.33 0.33 0">
                        <el-radio v-model="radios" label="1">选项1</el-radio>
                    </div>
                    <div style="flex: 0.33 0.33 0">
                        <el-radio v-model="radios" label="2">选项2</el-radio>
                    </div>
                    <div style="flex: 0.33 0.33 0">
                        <el-radio v-model="radios" label="3">选项3</el-radio>
                    </div>
                </div>
                <div class="radioCheckText" style="margin-right: 8px">多个选项中选择一个</div>

                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>

            <div class="fieldCheckbox" v-show="show===6">

                <div class="checkSelect">
                    <el-checkbox-group v-model="checkSelect" style="width: 100%;display: flex">
                        <div style="flex: 0.33 0.33 0">
                            <el-checkbox label="选项1"></el-checkbox>
                        </div>
                        <div style="flex: 0.33 0.33 0">
                            <el-checkbox label="选项2"></el-checkbox>
                        </div>
                        <div style="flex: 0.33 0.33 0">
                            <el-checkbox label="选项3"></el-checkbox>
                        </div>
                    </el-checkbox-group>
                </div>
                <div class="checkSeleckText" style="margin-right: 8px">可以选择多个选项</div>
                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>

            <div class="cascade" v-show="show===7">
                <div class="cascadeSelectProvince">
                    <el-select v-model="selectProvince" placeholder="请选择">
                        <el-option label="北京市" value="北京市"></el-option>
                        <el-option label="上海市" value="上海市"></el-option>
                    </el-select>
                </div>
                <div class="cascadeSelectCity">
                    <el-select v-model="selectCity" placeholder="请选择">
                        <el-option label="朝阳区" value="朝阳区"></el-option>
                        <el-option label="海淀区" value="海淀区"></el-option>
                    </el-select>
                </div>
                <div class="checkSeleckText" style="margin-right: 8px">级联,级联选项</div>
                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldImg"/>
            </div>

           <!-- <div class="blockBetween" v-if="show===8">
                <div class="blockBetweenPicker">
                    <el-date-picker
                            style="width: 100%;"
                            v-model="value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy - MM - dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"

                    >
                    </el-date-picker>
                </div>
                <div class="blockBetweenText">选择日期时间范围</div>
                <img src="../../../assets/images/fieldmanage/u2434.png" class="fieldInfoImg"/>
            </div>-->

            <div class="options"  v-show="show===4">
                <div class="optionsText"><span class="optionsTab">*</span>选项设置</div>
                <div class="optionsHead">

                    <div class="optionsSequence">顺序</div>

                    <div class="optionsName">选项名称</div>

                    <div class="optionsIsDefalut">是否默认值</div>

                    <div class="optionsIsoperation">操作</div>
                </div>
                <div class="optionSetInfo" id="radioOption">
                    <option-set v-for="(item,index) in radioOptions" :key="index"
                                :index="index+1"
                                :index2="index"
                                @delClick="delClick"
                                :content="item"
                                :radioOptions="radioOptions"
                                @radioChange="radioChange"
                                @resortOptionSet="resortOptionSet"
                    >
                    </option-set>
                </div>
                <div class="addOption" @click="addOptions">
                    <span><i class="el-icon-circle-plus-outline"></i>添加选项</span>
                </div>
            </div>
            <div class="options"  v-show="show===5">
                <div class="optionsText"><span class="optionsTab">*</span>选项设置</div>
                <div class="optionsHead">

                    <div class="optionsSequence">顺序</div>

                    <div class="optionsName">选项名称</div>

                    <div class="optionsIsDefalut">是否默认值</div>

                    <div class="optionsIsoperation">操作</div>

                    <!-- <img src="../../assets/images/fieldmanage/u2434.png" class="img"/>-->
                </div>
                <div id="radioOption2">
                    <option-set v-for="(item,index) in radioOptions" :key="index"
                                :index="index+1"
                                :index2="index"
                                @delClick="delClick"
                                :content="item"
                                :radioOptions="radioOptions"
                                @radioChange="radioChange"
                                @resortOptionSet="resortOptionSet"
                    >
                    </option-set>
                </div>
                <div class="addOption" @click="addOptions">
                    <span><i class="el-icon-circle-plus-outline"></i>添加选项</span>
                </div>
            </div>
            <div class="options"  v-show="show===6">
                <div class="optionsText"><span class="optionsTab">*</span>选项设置</div>
                <div class="optionsHead">

                    <div class="optionsSequence">顺序</div>

                    <div class="optionsName">选项名称</div>

                    <div class="optionsIsDefalut">是否默认值</div>

                    <div class="optionsIsoperation">操作</div>

                    <!-- <img src="../../assets/images/fieldmanage/u2434.png" class="img"/>-->
                </div>
                <div id="radioOption3">
                    <option-set v-for="(item,index) in radioOptions"
                                :key="index"
                                :index="index+1"
                                :index2="index"
                                @delClick="delClick"
                                :content="item"
                                :radioOptions="radioOptions"
                                @radioChange="radioChange"
                                @resortOptionSet="resortOptionSet"
                    >
                    </option-set>
                </div>
                <div class="addOption" @click="addOptions">
                    <span><i class="el-icon-circle-plus-outline"></i>添加选项</span>
                </div>
            </div>
          <!--  <div class="cascadeStyleSelect" v-if="show===7">
                <div class="StyleSelectText">选择样式</div>
                <div class="styleSelectRadio">
                    <el-radio v-model="styleRadio" label="1" border>经典样式</el-radio>
                    <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover">
                        <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;margin-right: 20px">
                        <div style="width:16px;height:16px; margin-right: 20px" slot="reference">
                            <img
                                    style="width:100%;height:100%;object-fit: cover;"
                                    src="../../../assets/images/fieldmanage/fieldCascade.png"
                                    alt
                            />
                        </div>

                    </el-popover>
                    <el-radio v-model="styleRadio" label="2" border>快速样式</el-radio>
                    <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover">
                        <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;margin-right: 20px">
                        <div style="width:16px;height:16px; margin-right: 20px" slot="reference">
                            <img
                                    style="width:100%;height:100%;object-fit: cover;"
                                    src="../../../assets/images/fieldmanage/fieldCascade.png"
                                    alt
                            />
                        </div>

                    </el-popover>
                </div>
            </div>-->
            <div class="cascadeOption" v-if="show===7" >
                <!--<div v-for="(item,Index) in CascadePullDown" :key="Index" style="height: 72px">
                    <div class="cascadeOptionText">选项设置</div>
                    <div style="display: flex">
                        <el-select style="flex: 0.9 0.9 0" v-model="cascadeOptionSelect[Index]"  placeholder="点击添加下拉选项">
                            <el-option
                                    v-for="(items,index) in item.optonValue"
                                    :key="index"
                                    :label="items.label"
                                    :value="items.value"
                            >
                                <div v-if="item.optonValue.length">
                                    <div style="display: flex">
                                        <div style="flex: 0.9 0.9 0">{{items.value}}</div>
                                        <div style="flex: 0.1 0.1 0">
                                            <img src="../../../assets/images/fieldmanage/up.png" style="width: 16px;height: 16px;margin-right: 5px" @click="upOption(Index,index)">
                                            <img src="../../../assets/images/fieldmanage/down.png" style="width: 16px;height: 16px;margin-right: 5px" @click="downOption(Index,index)">
                                            <img src="../../../assets/images/fieldmanage/rivese.png" style="width: 16px;height: 16px;margin-right: 5px" @click="riveseOption(Index,index)">
                                            <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px" @click="delOption(Index,index)">

                                        </div>
                                    </div>
                                </div>
                            </el-option>
                            <el-option
                                    key="1000000"
                                    value=""
                                    label=""
                                    v-if="!item.optonValue.length"
                            >
                                <div  v-if="showInput===0" style="text-align: center;font-size: 14px;color: #409EFF;cursor: pointer" @click="inputShow">添加选项</div>
                            </el-option>
                            <div v-if="showInput===1" style="display:flex;height: 64px;line-height: 64px;">
                                <div style="flex: 0.8 0.8 0">
                                    <el-input v-model="optionName" placeholder="请输入选项名称"></el-input>
                                </div>
                                <div style="flex: 0.2 0.2 0">
                                    <span style="margin-right: 16px;margin-left: 16px;color: red;font-size: 14px" @click="addCascadeOption(Index)">确认</span>
                                    <span style="font-size: 14px" @click="cacleInput(Index)">取消</span>
                                </div>

                            </div>
                        </el-select>
                        <div style="flex: 0.1 0.1 0" @click="delCascadeOption">
                            <img  src="../../../assets/images/fieldmanage/delred.png" style="width: 40px;margin-left: 12px;">
                        </div>

                    </div>
                </div>-->

                <div  v-if="addCascade1===1" style="height: 72px">
                    <div class="cascadeOptionText">选项设置</div>
                    <div style="display: flex">
                        <el-select style="flex: 1 1 0" v-model="cascadeOptionSelect1"  placeholder="点击添加下拉选项" @change="selectOption">
                            <div
                                    v-for="(items,index) in optionValue"
                                    :key="index"
                                    style="display: flex;width: 100%;"
                            >
                                <el-option

                                        :label="items.label"
                                        :value="items.value"
                                        v-if="rivese1!==index"
                                        style="flex: 1 1 0;line-height: 36px"

                                >
                                    <div>{{items.value}}</div>
                                </el-option>
                                <el-option

                                        label=" "
                                        value=""
                                        style="line-height: 1px;margin: 0;padding: 0"
                                        v-if="optionValue.length===1"
                                >
                                </el-option>
                                <div v-if="rivese1===index" style="flex: 1 1 0;line-height: 36px;display:flex;">
                                    <div style="flex: 0.8 0.8 0;height: 56px">
                                        <el-input v-model="riveseName1" placeholder="请输入选项名称"></el-input>
                                    </div>
                                    <div style="flex: 0.2 0.2 0;text-align: right">
                                        <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 12px;cursor: pointer" @click="rivese1Option">确认</span>
                                        <span style="font-size: 12px;cursor: pointer" @click="cacleRivese1">取消</span>
                                    </div>

                                </div>
                                <div style="width:100px;text-align: right;line-height: 36px;cursor: pointer;margin-right:8px;">
                                    <img src="../../../assets/images/fieldmanage/up.png" style="width: 16px;height: 16px;margin-right: 5px"  v-show="index > 0"  @click="upOption1(index)">
                                    <img src="../../../assets/images/fieldmanage/down.png" style="width: 16px;height: 16px;margin-right: 5px"  v-show="index<optionValue.length-1" @click="downOption1(index)">
                                    <img src="../../../assets/images/fieldmanage/rivese.png" style="width: 16px;height: 16px;margin-right: 5px" @click="riveseOption1(index,items.value)">
                                    <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px" @click="delOption1(index,items.value)">

                                </div>
                            </div>

                            <el-option
                                    key="1000000"
                                    value=""
                                    label=""
                                    style="height: 1px"
                                    v-if="optionValue.length ===0"
                            >
                            </el-option>
                            <div  v-if="showInput1===0" style="text-align: center;font-size: 14px;color: #409EFF;cursor: pointer;line-height: 32px;margin-bottom: 10px" @click="inputShow1">添加选项</div>

                            <div v-if="showInput1===1" style="display:flex;height: 64px;line-height: 40px;">
                                <div style="flex: 0.8 0.8 0">
                                    <el-input v-model="optionName" placeholder="请输入选项名称"></el-input>
                                </div>
                                <div style="flex: 0.2 0.2 0;text-align: right;margin-right: 8px">
                                    <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 14px;cursor: pointer" @click="addCascadeOption">确认</span>
                                    <span style="font-size: 14px;cursor: pointer" @click="cacleInput1">取消</span>
                                </div>

                            </div>

                        </el-select>
                        <div style="line-height: 52px" @click="delCascadeOption1">
                            <img  src="../../../assets/images/fieldmanage/delred.png" style="width: 24px;height:24px;margin-left: 12px;">
                        </div>

                    </div>
                </div>

                <div v-if="addCascade===2" style="height: 72px">
                    <div class="cascadeOptionText">选项设置</div>
                    <div style="display: flex">
                        <el-select style="flex: 1 1 0" v-model="cascadeOptionSelect2"  placeholder="点击添加下拉选项" @change="selectOption2">

                            <div  v-for="(items,index) in OptionChildren"
                                  :key="index"
                                  style="display: flex;width: 100%"
                            >
                                <el-option

                                        :label="items.label"
                                        :value="items.value"
                                        v-if="rivese2!==index"
                                        style="flex: 1 1 0;line-height: 36px"
                                >
                                    <div >{{items.value}}</div>
                                </el-option>
                                <el-option

                                        label=" "
                                        value=""
                                        style="line-height: 1px;margin: 0;padding: 0"
                                        v-if="OptionChildren.length===1"
                                >
                                </el-option>
                                <div v-if="rivese2===index" style="flex: 1 1 0;line-height: 36px;display:flex;">
                                    <div style="flex: 0.8 0.8 0;height: 56px">
                                        <el-input v-model="riveseName2" placeholder="请输入选项名称"></el-input>
                                    </div>
                                    <div style="flex: 0.2 0.2 0;text-align: right;">
                                        <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 12px;cursor: pointer" @click="resiveOption2">确认</span>
                                        <span style="font-size: 12px;cursor: pointer" @click="cacleRivese2">取消</span>
                                    </div>

                                </div>
                                <div style="width:100px;text-align: right;line-height: 36px;cursor: pointer;margin-right:8px;">
                                    <img src="../../../assets/images/fieldmanage/up.png" style="width: 16px;height: 16px;margin-right: 5px" v-show="index > 0"  @click="upOption2(index)">
                                    <img src="../../../assets/images/fieldmanage/down.png" style="width: 16px;height: 16px;margin-right: 5px"  v-show="index<OptionChildren.length-1" @click="downOption2(index)">
                                    <img src="../../../assets/images/fieldmanage/rivese.png" style="width: 16px;height: 16px;margin-right: 5px" @click="riveseOption2(index,items.value)">
                                    <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px" @click="delOption2(index,items.value)">

                                </div>
                            </div>

                            <el-option
                                    key="1000000"
                                    value=""
                                    label=""
                                    style="height: 1px"
                                    v-if="OptionChildren.length ===0"
                            >
                            </el-option>
                            <div  v-if="showInput2===0" style="text-align: center;font-size: 14px;color: #409EFF;cursor: pointer;line-height: 32px;margin-bottom: 10px" @click="inputShow2">添加选项</div>

                            <div v-if="showInput2===1" style="display:flex;height: 64px;line-height: 40px;">
                                <div style="flex: 0.8 0.8 0">
                                    <el-input v-model="optionName2" placeholder="请输入选项名称"></el-input>
                                </div>
                                <div style="flex: 0.2 0.2 0;text-align: right;margin-right: 8px">
                                    <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 14px;cursor: pointer" @click="addCascadeOption2">确认</span>
                                    <span style="font-size: 14px;cursor: pointer" @click="cacleInput2">取消</span>
                                </div>

                            </div>

                        </el-select>
                        <div style="line-height: 52px" @click="delCascadeOption2">
                            <img  src="../../../assets/images/fieldmanage/delred.png" style="width: 24px;margin-left: 12px;">
                        </div>

                    </div>
                </div>

                <div style="height: 72px" v-if="addCascade2===3">
                    <div class="cascadeOptionText">选项设置</div>
                    <div style="display: flex">
                        <el-select style="flex: 1 1 0" v-model="cascadeOptionSelect3"  placeholder="点击添加下拉选项" >

                            <div  v-for="(items,index) in OptionChildren2"
                                  :key="index"
                                  style="display: flex;width: 100%"
                            >
                                <el-option

                                        label=" "
                                        value=""
                                        style="line-height: 1px;margin: 0;padding: 0"
                                        v-if="OptionChildren2.length===1"
                                >
                                </el-option>
                                <el-option

                                        :label="items.label"
                                        :value="items.value"
                                        v-if="rivese3!==index"
                                        style="flex: 1 1 0;line-height: 36px"
                                >

                                    <div >{{items.value}}</div>


                                </el-option>

                                <div v-if="rivese3===index" style="display:flex;flex: 1 1 0;line-height: 36px">
                                    <div style="flex: 0.8 0.8 0;height: 56px">
                                        <el-input v-model="riveseName3" placeholder="请输入选项名称"></el-input>
                                    </div>
                                    <div style="flex: 0.2 0.2 0;text-align: right">
                                        <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 12px;cursor: pointer" @click="rivese3Option">确认</span>
                                        <span style="font-size: 12px;cursor: pointer" @click="cacleRivese3">取消</span>
                                    </div>

                                </div>
                                <div style="width:100px;text-align: right;margin-right:8px;line-height: 36px;cursor: pointer">
                                    <img src="../../../assets/images/fieldmanage/up.png" style="width: 16px;height: 16px;margin-right: 5px" v-show="index > 0" @click="upOption3(index)">
                                    <img src="../../../assets/images/fieldmanage/down.png" style="width: 16px;height: 16px;margin-right: 5px" v-show="index<OptionChildren2.length-1" @click="downOption3(index)">
                                    <img src="../../../assets/images/fieldmanage/rivese.png" style="width: 16px;height: 16px;margin-right: 5px" @click="riveseOption3(index,items.value)">
                                    <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px" @click="delOption3(index,items.value)">

                                </div>
                            </div>

                            <el-option
                                    key="1000000"
                                    value=""
                                    label=""
                                    style="height: 1px"
                                    v-if="OptionChildren2.length===0"
                            >
                            </el-option>
                            <div  v-if="showInput3===0" style="text-align: center;font-size: 14px;color: #409EFF;cursor: pointer;line-height: 32px;margin-bottom: 10px" @click="inputShow3">添加选项</div>

                            <div v-if="showInput3===1" style="display:flex;height: 64px;line-height: 40px;">
                                <div style="flex: 0.8 0.8 0">
                                    <el-input v-model="optionName3" placeholder="请输入选项名称"></el-input>
                                </div>
                                <div style="flex: 0.2 0.2 0;text-align: right;margin-right: 8px">
                                    <span style="margin-right: 8px;margin-left: 8px;color: red;font-size: 14px;cursor: pointer" @click="addCascadeOption3">确认</span>
                                    <span style="font-size: 14px;cursor: pointer" @click="cacleInput3">取消</span>
                                </div>

                            </div>

                        </el-select>
                        <div style="line-height: 52px" @click="delCascadeOption3">
                            <img  src="../../../assets/images/fieldmanage/delred.png" style="width: 24px;margin-left: 12px;">
                        </div>

                    </div>
                </div>

            </div>
            <div v-if="show===7&&addCascade2!==3" style="line-height: 48px; text-align: center;color: #409EFF;font-size: 14px;cursor: pointer" @click="addCascadePullDown">+添加级联下拉</div>


            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="modifyFieldClick">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="删除字段"  :visible.sync="dialogFormVisible" custom-class="deleteField" :close-on-click-modal="false">
            <div class="fieldDialogDelText">删除该字段后，工单内该字段的数据都将清空，并且请检查过滤器设置</div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="danger"  @click="deleteFieldInfo">删 除</el-button>
            </div>
        </el-dialog>

        <el-dialog title="删除子级"  :visible.sync="dialogFormVisibleDelete" custom-class="deleteField" >
            <div class="fieldDialogDelText">该级存在子级选项，删除将会全部删除，是否删除</div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleDelete = false">取 消</el-button>
                <el-button type="danger" @click="deleteOption(items.id)">删 除</el-button>
            </div>
        </el-dialog>

        <el-dialog title="删除子级"  :visible.sync="dialogFormVisibleDelete2" custom-class="deleteField" >
            <div class="fieldDialogDelText">该级存在子级选项，删除将会全部删除，是否删除</div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleDelete2 = false">取 消</el-button>
                <el-button type="danger" @click="deleteAllOption">删 除</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import OptionSet from "../../../components/context/optionset/OptionSet";
    import {deletePackage} from "../../../network";
    import Sortable from "sortablejs";
    export default {
        name: "FieldInfo",
        components:{OptionSet},
        props:{
            items:
                {
                    type:Object,
                    default(){
                        return{}
                    }
                },
            index:Number,
            fieldList:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        filters:{
            typeLable(value){
                if (value==='INPUT'){
                    return '单行文本'
                }
                if (value==='SELECT'){
                    return '下拉列表'
                }
                if (value==='CASCADER'){
                    return '级联选择'
                }
                if (value==='RADIO'){
                    return '单选框'
                }
                if (value==='CHECKBOX'){
                    return '复选框'
                }
                if (value==='TIME_PICKER'){
                    return '时间选择'
                }
                if (value==='DATE_PICKER'){
                    return '日期选择'
                }
                if (value==='DATETIME_RANGE'){
                    return '日期和时间范围'
                }
                if (value==='TEXTAREA'){
                    return '多行文本'
                }
            }
        },
        data(){
            return{
                dialogFormVisible: false,
                dialogFormVisible1:false,
                dialogFormVisibleDelete2:false,
                dialogFormVisibleDelete:false,
                option:'',
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                formLabelWidth: '120px',
                singleText:'',
                radio: '2',
                show:'',
                stepBar:'',
                active: 0,
                datePicker:'2020-08-02',
                value2:'2020-08-02',
                textarea:'',
                radioLabel:'',
                select:'选项1',
                select2:[],
                time1: '12:40:15',
                time2: '',
                radios:'1',
                checkSelect:['选项1','选项2'],
                text:'',
                options: [{
                    value: '单行文本',
                    label: '单行文本'
                }, {
                    value: '多行文本',
                    label: '多行文本'
                }, {
                    value: '下拉列表',
                    label: '下拉列表'
                }, {
                    value: '级联选择',
                    label: '级联选择'
                }, {
                    value: '单选框',
                    label: '单选框'
                },
                    {
                        value: '复选框',
                        label: '复选框'
                    },
                    {
                        value: '日期选择',
                        label: '日期选择'
                    },
                    {
                        value: '时间选择',
                        label: '时间选择'
                    }
                ],
                addOption:['1','2'],
                optionnum:1,
                fieldType:'',
                modifyField:{
                    name:'',
                    description:'',
                    type:'',
                    extInfo:[]
                },
                extInfos:{
                    exinfo:[

                    ],
                    cascadeDown:[
                        {
                            style:'',
                            options:[]}
                    ]
                },
                itemExtInfo:[],
                filedName:'',
                filedDescription:'',
                radioOptions:[{value:'',_default:'false'},{value:'',_default:'false'}],
                selectProvince:'',
                selectCity:'',
                styleRadio:'1',
                cascadeOption:[],
                cascadeOptionSelect:[],
                showInput:0,
                optionName:'',
                CascadePullDown:[
                    {optonValue:[]}
                ],
                optionValue:[],
                selectOptions:[],
                radioFiledOptions:[],
                checkBoxFiledOptions:[],
                isScreen:true,
                addCascade1:1,
                addCascade:0,
                addCascade2:0,
                cascadeOptionSelect1:'',
                cascadeOptionSelect2:'',
                cascadeOptionSelect3:'',
                selectOption1:[],
                optionName2:'',
                optionName3:"",
                cascadeOptionChildren:"",
                OptionChildren:[],
                OptionChildren2:[],
                cascadeOptionChildren2:'',
                fristOption:1,
                secondOption:1,
                thirdOption:1,
                fristName:'',
                secondName:'',
                thirdName:'',
                showInput1:0,
                showInput2:0,
                showInput3:0,
                num2:0,
                deleteOption1:1,
                deleteOption2:1,
                defaultValue:'true',
                deleteOption2Index:'',
                deleteOptionIndex:'',
                rivese1:'',
                rivese2:'',
                rivese3:'',
                riveseName1:'',
                riveseName2:'',
                riveseName3:'',
                riveseIndex1:'',
                riveseIndex2:'',
                riveseIndex3:'',
                cascadeOptionSelect1Num:0,
                cascadeOptionSelect2Num:0,
                cascadeOptionSelect3Num:0,
                fieldId:'',
                fiedDetail:[],
                test:{}
            }
        },
        created() {

        },
        mounted() {


        },
        methods:{
            //获取行样式
            getRowClass(){
                return 'fieldRowClass'
            },

            selectType(value){
                if(value==='单行文本'){
                    this.show=0
                    this.radio='2'
                }
                if(value==='多行文本'){
                    this.show=1
                    this.radio='2'

                }
                if(value==='日期的选择'){
                    this.show=2
                    this.radio='1'
                }
                if(value==='时间选择'){
                    this.show=3
                    this.radio='1'
                }
                if(value==='下拉列表'){
                    this.show=4;
                    this.radio='1'
                }
                if(value==='单选框'){
                    this.show=5
                    this.radio='1'
                }
                if(value==='复选框'){
                    this.show=6
                    this.radio='1'
                }
                if(value==='级联选择'){
                    this.show=7
                    this.radio='1'
                }
                if(value==='日期和时间范围'){
                    this.show=8
                    this.radio='2'
                }
                this.stepBar=0
                this.active=1
                this.radioOptions=[{value:'',_default:'false'},{value:'',_default:'false'}]

            },
            change(label){
                this.radio=label
            },
            chang2(label){
                this.radio=label
            },
            addOptions(){
                this.radioOptions.push({value: '', _default: 'false'});
                console.log(
                    'addOptions', this.radioOptions);
            },
            delClick(index){
                this.radioOptions.splice(index - 1, 1);
                console.log(this.radioOptions)
            },
            deleteFieldInfo(){
                deletePackage(this.requestUrl.field.deleteField,this.fieldId).then(res=>{
                    if(res.code==='0'){
                        this.$message.success('删除字段成功')
                    }
                    else{
                        this.$message.error(res.message)
                    }
                    this.$emit('deleteFieldInfo')
                })
                this.dialogFormVisible = false

            },
            modifyFieldClick(){

                if( this.fieldType==="单行文本"){
                    this.modifyField.type='INPUT'
                }
                if( this.fieldType==="多行文本"){
                    this.modifyField.type='TEXTAREA'
                }
                if( this.fieldType==="下拉列表"){
                    this.modifyField.type='SELECT'
                }
                if( this.fieldType==="级联选择"){
                    this.modifyField.type='CASCADER'
                }
                if( this.fieldType==="单选框"){
                    this.modifyField.type='RADIO'
                }
                if( this.fieldType==="复选框"){
                    this.modifyField.type='CHECKBOX'
                }
                if( this.fieldType==="时间选择"){
                    this.modifyField.type='TIME_PICKER'
                }
                if( this.fieldType==="日期选择"){
                    this.modifyField.type='DATE_PICKER'
                }
                if( this.fieldType==="选择日期时间范围"){
                    this.modifyField.type='DATETIME_RANGE'
                }
                if(this.radio===1)
                    this.isScreen=true
                if(this.radio===2)
                    this.isScreen=false
                let radioOptionsList=[]
                this.radioOptions.forEach(item=>{
                    if(item.value!=='')
                        radioOptionsList.push(item)
                })
                this.extInfos.exinfo=radioOptionsList
                this.extInfos.cascadeDown[0].style=this.styleRadio
                this.extInfos.cascadeDown[0].options=this.optionValue
                this.optionValue.forEach(item=>{
                    console.log(item)
                    if(item.children!==undefined)
                    {
                        if(item.children.length===0)
                            delete item.children
                        else {
                            item.children.forEach(items=>{
                                if(items.children!==undefined)
                                {
                                    if(items.children.length===0)
                                        delete items.children
                                }

                            })
                        }
                    }

                })
                console.log(this.optionValue)
                if(this.filedName!=='')
                {
                    if(this.modifyField.type==='SELECT'||this.modifyField.type==='RADIO'||this.modifyField.type==='CHECKBOX') {
                        let radioOption = {}
                        this.radioOptions.forEach((item, index) => {
                            if (item.value !== '') {
                                radioOption[index] = item
                            }
                        })
                        if (Object.keys(radioOption).length === 0) {
                            this.$message.error('请设置选项')
                        }
                    else
                        {
                            this.$http.put('/api/field/'+ this.fieldId,{
                                createTime:this.items.createTime,
                                name:this.filedName,
                                description:this.filedDescription,
                                type: this.modifyField.type,
                                searchable:this.isScreen,
                                extInfo:this.extInfos,
                                updateTime:new Date(),
                                "operatorId": "test_uid",
                                "mainId": "test_mid",
                            }).then(res=>{
                                if(res.data.code==='0')
                                {
                                    this.$message.success('修改字段成功')
                                }
                                this.$emit('modifyFieldClick',this.fieldType)
                            })
                            /* putPackage(this.requestUrl.field.putField,this.items.id,this.modifyField).then(res=>{
                                 if(res.code==='0'){
                                     this.$message.success("修改字段成功")
                                 }
                                 else{
                                     this.$message.error(res.message)
                                 }
                                 this.$emit('modifyFieldClick',this.fieldType)
                             })*/
                            this.radioOptions=[{value:'',_default:'false'},{value:'',_default:'false'}]
                            this.dialogFormVisible1=false
                        }
                    }
                    else
                    {
                        this.$http.put('/api/field/'+this.fieldId,{
                            createTime:this.items.createTime,
                            name:this.filedName,
                            description:this.filedDescription,
                            type: this.modifyField.type,
                            searchable:this.isScreen,
                            extInfo:this.extInfos,
                            updateTime:new Date(),
                            "operatorId": "test_uid",
                            "mainId": "test_mid",
                        }).then(res=>{
                            if(res.data.code==='0')
                            {
                                this.$message.success('修改字段成功')
                            }
                            this.$emit('modifyFieldClick',this.fieldType)
                        })
                        /* putPackage(this.requestUrl.field.putField,this.items.id,this.modifyField).then(res=>{
                             if(res.code==='0'){
                                 this.$message.success("修改字段成功")
                             }
                             else{
                                 this.$message.error(res.message)
                             }
                             this.$emit('modifyFieldClick',this.fieldType)
                         })*/
                        this.radioOptions=[{value:'',_default:'false'},{value:'',_default:'false'}]
                        this.dialogFormVisible1=false
                    }

                }
                else
                    this.$message.error('请输入字段名称')


            },
            optionInputClick(value){
                const option={}
                option.value=value
                option.label=value
                if(value!==''){
                    this.extInfos.extinfo=option
                }

            },
            addCascadeOption(){
                /* this.optionValue[index].value=this.optionName
                 this.optionValue[index].label=this.optionName
                 this.optionValue[index].children=[]*/
                if(this.optionName!=='')
                {
                    this.optionValue.push({value:this.optionName,label:this.optionName,children: []})
                    this.fristOption=1
                    this.optionName=''
                }
                else
                    this.$message.error('请输入选项名称')


                /*   this.CascadePullDown[index].optonValue.push({value:this.optionName,label:this.optionName})
                     this.optionValues=this.CascadePullDown[0].optonValue
                     if(index > 0){
                         this.selectCitys=this.CascadePullDown[1].optonValue

                     }
                     if(index > 1)
                     {
                         this.nextDown=this.CascadePullDown[2].optonValue
                     }
     */

            },
            addCascadeOption2(){
                if(this.optionName2!=='')
                {
                    this.optionValue.forEach(item=>{
                        if(item.value===this.cascadeOptionSelect1)
                        {
                            if(item.children===undefined)
                            {
                                this.$set(item,'children',[])
                                item.children.push({value:this.optionName2,label:this.optionName2,children:[]})
                                this.OptionChildren=item.children

                                this.secondOption=1
                            }
                            else {
                                item.children.push({value:this.optionName2,label:this.optionName2,children:[]})
                                this.OptionChildren=item.children

                                this.secondOption=1
                            }



                        }

                    })
                    this.optionName2=''
                }
                else
                    this.$message.error('请输入选项名称')


            },
            addCascadeOption3(){
                if(this.optionName3!=='')
                {
                    this.optionValue.forEach(item=>{
                        if(item.children!==undefined)
                        {
                            item.children.forEach(items=>{
                                if(items.value===this.cascadeOptionSelect2)
                                {
                                    console.log(items.value)
                                    if(items.children===undefined)
                                    {

                                        this.$set(items,'children',[])
                                        items.children.push({value:this.optionName3,label:this.optionName3})
                                        this.OptionChildren2=items.children
                                        this.thirdOption=1
                                        console.log(items)
                                        console.log(this.OptionChildren2)
                                    }
                                    else {
                                        items.children.push({value:this.optionName3,label:this.optionName3})

                                        this.OptionChildren2=items.children
                                        console.log(this.OptionChildren2)


                                        this.thirdOption=1
                                    }

                                }
                            })
                        }

                    })
                    this.optionName3=''
                }
                else
                    this.$message.error('请输入选项名称')
                console.log(this.cascadeOptionSelect2)

            },
           /* delOption1(index,value)
            {
              if(this.optionValue[index].children!==undefined)
              {
                if(this.optionValue[index].children.length > 0)
                {
                  this.dialogFormVisibleDelete=true
                  this.fristOption=0
                  this.fristName=value
                  this.deleteOption1=2
                  this.deleteOptionIndex=index
                }
                else {
                  this.optionValue.splice(index,1)
                  if(this.cascadeOptionSelect1===value)
                  {
                    this.cascadeOptionSelect1=''
                    this.cascadeOptionSelect2=''
                    this.cascadeOptionSelect3=''
                  }

                }
                this.riveseName1=''
                console.log(value)
              }
              else {
                this.optionValue.splice(index,1)
                if(this.cascadeOptionSelect1===value)
                {
                  this.cascadeOptionSelect1=''
                  this.cascadeOptionSelect2=''
                  this.cascadeOptionSelect3=''
                }

              }



            },*/
          delOption1(index,value)
          {
            if(this.optionValue[index].children!==undefined)
            {
              if(this.optionValue[index].children.length > 0)
              {
                this.dialogFormVisibleDelete=true
                this.fristOption=0
                this.fristName=value
                this.deleteOption1=2
                this.deleteOptionIndex=index
              }
              else {
                this.optionValue.splice(index,1)
                if(this.cascadeOptionSelect1===value)
                {
                  this.cascadeOptionSelect1=''
                  this.cascadeOptionSelect2=''
                  this.cascadeOptionSelect3=''
                }

              }
              this.riveseName1=''
              console.log(value)
            }
            else {
              this.optionValue.splice(index,1)
              if(this.cascadeOptionSelect1===value)
              {
                this.cascadeOptionSelect1=''
                this.cascadeOptionSelect2=''
                this.cascadeOptionSelect3=''
              }

            }



          },
            riveseOption1(index1,value){
                this.showInput1=2
                this.rivese1=index1
                this.riveseName1=value
                this.riveseIndex1=index1
                console.log(index1,value)
                if(value===this.cascadeOptionSelect1)
                {
                    console.log('aaa')
                    this.cascadeOptionSelect1Num=1
                }

            },
            rivese1Option(){
                if(this.riveseName1!=='')
                {
                    if(this.cascadeOptionSelect1Num===1)
                    {
                        this.cascadeOptionSelect1=this.riveseName1
                    }
                    this.optionValue[this.riveseIndex1].value=this.riveseName1
                    this.optionValue[this.riveseIndex1].label=this.riveseName1
                    this.riveseName1=''
                    this.rivese1=''
                    this.cascadeOptionSelect1Num=0
                }
                else
                    this.$message.error('请输入选项名称')
                this.showInput1=0
            },

            upOption1(index){
                let tempOption = this.optionValue[index];
                this.$set(this.optionValue, index, this.optionValue[index - 1]);
                this.$set(this.optionValue, index - 1, tempOption)

            },
            downOption1(index){
                let temp = this.optionValue[index]
                this.$set(this.optionValue,index,this.optionValue[index+1])
                this.$set(this.optionValue,index+1,temp)

            },
           /* delOption2(index,value)
                {
                    console.log(value)
                    this.optionValue.forEach((item)=>{
                        if(item.value===this.cascadeOptionSelect1)
                        {
                            if(item.children!=undefined)
                            {
                                if(item.children.length > 0)
                                {
                                    item.children.forEach((items,index)=>{
                                        if(items.value===value)
                                        {
                                            console.log(items.value)
                                            console.log(items)
                                            console.log(index)
                                            if(items.children!==undefined)
                                            {
                                                this.dialogFormVisibleDelete = true
                                                this.secondOption = 0
                                                this.secondName=value
                                                this.deleteOption2=2
                                                this.deleteOption2Index=index
                                            }
                                            else
                                            {
                                                item.children.splice(index,1)
                                            }


                                        }

                                    })
                                }
                                else
                                {
                                    item.children.splice(index,1)
                                }
                            }

                        }
                    })
                    this.riveseName2=''
                    /!* for (let i =0;i<this.optionValue.length;i++) {
                             for (let j = 0; j < this.OptionChildren.length; j++) {
                                 if(this.optionValue[i].children.length >0){
                                     if(this.optionValue[i].children[j].value===value)
                                     {
                                             if (this.optionValue[i].children[j].children.length > 0) {
                                                 this.dialogFormVisibleDelete = true
                                                 this.secondOption = 0
                                                 this.secondName=value
                                                 this.deleteOption2=2
                                             }
                                             else {
                                                 console.log(this.OptionChildren)
                                                 this.optionValue[i].children.splice(j,1)

                                             }
                                         }
                                         else
                                         {
                                             this.OptionChildren.splice(j,1)
                                             this.optionValue[i].children.splice(j, 1)

                                         }

                                 }


                                    console.log(this.optionValue[i].children[index].children)
                                 console.log(this.optionValue)
                                /!* if(this.optionValue[i].children[index].children)
                                 {
                                     if (this.optionValue[i].children[index].children.length > 0) {
                                         console.log('cccc')
                                         this.dialogFormVisibleDelete = true
                                         this.secondOption = 0
                                         this.secondName=value
                                     }
                                     else {
                                         console.log(this.OptionChildren)
                                          this.OptionChildren.splice(index,1)
                                         this.optionValue[i].children.splice(j, 1)
                                     }
                                 }
                                else
                                 {
                                      this.OptionChildren.splice(index,1)
                                     this.optionValue[i].children.splice(j, 1)
                                     }

     *!/

                             }


                     }*!/
                },*/
          delOption2(index,value)
          {
            console.log(value)
            this.optionValue.forEach((item)=>{
              if(item.value===this.cascadeOptionSelect1)
              {
                if(item.children!=undefined)
                {
                  if(item.children.length > 0)
                  {
                    item.children.forEach((items,index)=>{
                      if(items.value===value)
                      {
                        console.log(items.value)
                        console.log(items)
                        console.log(index)
                        if(items.children!==undefined)
                        {
                          if(items.children.length > 0)
                          {
                            this.dialogFormVisibleDelete = true
                            this.secondOption = 0
                            this.secondName=value
                            this.deleteOption2=2
                            this.deleteOption2Index=index
                          }
                          else
                          {
                            item.children.splice(index,1)
                          }

                        }
                        else
                        {
                          item.children.splice(index,1)
                        }


                      }

                    })
                  }
                  else
                  {
                    item.children.splice(index,1)
                  }
                }

              }
            })
            this.riveseName2=''
            /* for (let i =0;i<this.optionValue.length;i++) {
                     for (let j = 0; j < this.OptionChildren.length; j++) {
                         if(this.optionValue[i].children.length >0){
                             if(this.optionValue[i].children[j].value===value)
                             {
                                     if (this.optionValue[i].children[j].children.length > 0) {
                                         this.dialogFormVisibleDelete = true
                                         this.secondOption = 0
                                         this.secondName=value
                                         this.deleteOption2=2
                                     }
                                     else {
                                         console.log(this.OptionChildren)
                                         this.optionValue[i].children.splice(j,1)

                                     }
                                 }
                                 else
                                 {
                                     this.OptionChildren.splice(j,1)
                                     this.optionValue[i].children.splice(j, 1)

                                 }

                         }


                            console.log(this.optionValue[i].children[index].children)
                         console.log(this.optionValue)
                        /!* if(this.optionValue[i].children[index].children)
                         {
                             if (this.optionValue[i].children[index].children.length > 0) {
                                 console.log('cccc')
                                 this.dialogFormVisibleDelete = true
                                 this.secondOption = 0
                                 this.secondName=value
                             }
                             else {
                                 console.log(this.OptionChildren)
                                  this.OptionChildren.splice(index,1)
                                 this.optionValue[i].children.splice(j, 1)
                             }
                         }
                        else
                         {
                              this.OptionChildren.splice(index,1)
                             this.optionValue[i].children.splice(j, 1)
                             }

*!/

                     }


             }*/
          },

                /*for (let i =0;i<this.optionValue.length;i++) {
                    console.log(this.optionValue[i])
                    for (let j = 0; j < this.OptionChildren.length; j++) {

                        if(this.optionValue[i].children[j].value===this.OptionChildren[index].value)
                        {
                            this.num2=j
                            if(this.optionValue[i].children[j].children)
                            {
                                if (this.optionValue[i].children[j].children.length > 0) {
                                    this.dialogFormVisibleDelete = true
                                    this.secondOption = 0
                                    this.secondName=value
                                    this.deleteOption2=2
                                }
                                else {
                                    console.log(this.OptionChildren)
                                    this.OptionChildren.splice(index,1)

                                }
                            }
                            else
                            {
                                this.OptionChildren.splice(index,1)
                                this.optionValue[i].children.splice(this.num2, 1)

                            }
                        }

                        console.log(this.optionValue[i].children[j].children)
                        console.log(this.optionValue)
                        /!* if(this.optionValue[i].children[index].children)
                         {
                             if (this.optionValue[i].children[index].children.length > 0) {
                                 console.log('cccc')
                                 this.dialogFormVisibleDelete = true
                                 this.secondOption = 0
                                 this.secondName=value
                             }
                             else {
                                 console.log(this.OptionChildren)
                                  this.OptionChildren.splice(index,1)
                                 this.optionValue[i].children.splice(j, 1)
                             }
                         }
                        else
                         {
                              this.OptionChildren.splice(index,1)
                             this.optionValue[i].children.splice(j, 1)
                             }

*!/

                    }


                }*/

            riveseOption2(index,value){
                this.rivese2=index
                this.showInput2=2
                this.riveseName2=value
                this.riveseIndex2=index
                if(value===this.cascadeOptionSelect2)
                {
                    this.cascadeOptionSelect2Num=1
                }
            },
            resiveOption2(){
                if(this.riveseName2!=='')
                {
                    if(this.cascadeOptionSelect2Num===1)
                        this.cascadeOptionSelect2=this.riveseName2
                    this.optionValue.forEach(item=>{
                        if(item.value===this.cascadeOptionSelect1)
                        {
                            item.children[this.riveseIndex2].value=this.riveseName2
                            item.children[this.riveseIndex2].label=this.riveseName2
                            this.OptionChildren[this.rivese2]=item.children[this.rivese2]
                            this.riveseName2=''
                            this.rivese2=''
                        }
                    })
                    this.cascadeOptionSelect2Num=0

                }
                else
                    this.$message.error('请输入选项名称')

                 this.showInput2=0

            },
            upOption2(index){
                let tempOption = this.OptionChildren[index];
                this.$set(this.OptionChildren, index, this.OptionChildren[index - 1]);
                this.$set(this.OptionChildren, index - 1, tempOption)

            },
            downOption2(index){
                let temp = this.OptionChildren[index]
                this.$set(this.OptionChildren,index,this.OptionChildren[index+1])
                this.$set(this.OptionChildren,index+1,temp)

            },
            delOption3(index,value)
            {
                this.OptionChildren2.splice(index,1)
                for (let i = 0; i< this.optionValue.length;i++)
                {
                    for (let j =0;j<this.optionValue[i].children.length;j++)
                    {
                        for (let k=0;k<this.optionValue[i].children[j].length ;k++)
                        {

                            if(this.optionValue[i].children[j].children[k].value===value)
                                this.optionValue[i].children[j].children.splice(k,1)
                        }



                    }
                }
                this.riveseName3=''
                this.cascadeOptionSelect3=''
              /*  this.OptionChildren2.splice(index,1)
                for (let i = 0; i< this.optionValue.length;i++)
                {
                    for (let j =0;j<this.optionValue[i].children.length;j++)
                    {
                        for (let k=0;k<this.optionValue[i].children[j].length ;k++)
                        {

                            if(this.optionValue[i].children[j].children[k].value===value)
                                this.optionValue[i].children[j].children.splice(k,1)
                        }



                    }
                }

*/


            },
            riveseOption3(index1,value){
                this.rivese3=index1
                this.showInput3=2
                this.riveseName3=value
                this.riveseIndex3=index1
                if(value===this.cascadeOptionSelect3)
                    this.cascadeOptionSelect3Num=1
            },
            rivese3Option(){
                this.showInput3=0
                if(this.riveseName3!=='')
                {
                    if(this.cascadeOptionSelect3Num===1)
                        this.cascadeOptionSelect3=this.riveseName3
                    this.optionValue.forEach(item=>{
                        item.children.forEach(items=>{
                            console.log(items)
                            if(items.value===this.cascadeOptionSelect2)
                            {

                                items.children[this.riveseIndex3].value=this.riveseName3
                                items.children[this.riveseIndex3].label=this.riveseName3
                                this.OptionChildren2[this.rivese3]=items.children[this.rivese3]
                                this.rivese3=''
                            }

                        })
                    })
                    this.cascadeOptionSelect3Num=0

                }

                else
                    this.$message.error('请输入选项名称')


            },
            upOption3(index){
                let tempOption = this.OptionChildren2[index];
                this.$set(this.OptionChildren2, index, this.OptionChildren2[index - 1]);
                this.$set(this.OptionChildren2, index - 1, tempOption)

            },
            downOption3(index){
                let temp = this.OptionChildren2[index]
                this.$set(this.OptionChildren2,index,this.OptionChildren2[index+1])
                this.$set(this.OptionChildren2,index+1,temp)

            },
            delCascadeOption1(){
                this.optionValue.forEach(item=>{
                    if(item.children.length > 0 || this.OptionChildren.length > 0)
                    {
                        this.dialogFormVisibleDelete2=true
                        this.fristOption=0
                    }
                    else
                    {
                        this.optionValue=[]
                        this.OptionChildren2=[]
                        this.OptionChildren=[]
                        this.addCascade=0
                        this.addCascade2=0
                        this.cascadeOptionSelect1=''

                    }


                })
                /*for (let i =0;i<this.optionValue.length;i++)
                {
                        if(this.optionValue[i].children.length > 0)
                        {

                        }
                        else {


                        }

                }*/


            },
            delCascadeOption2(){
                this.optionValue.forEach(item=>{
                    if(item.children!==undefined)
                    {
                        item.children.forEach(items=>{
                            console.log(items)
                            if(items.children!==undefined)
                            {
                                if(items.children.length > 0 ||this.OptionChildren2.length > 0)
                                {
                                    this.dialogFormVisibleDelete2=true
                                    this.secondOption=0
                                }
                                else
                                {
                                    this.cascadeOptionSelect2=''
                                    this.addCascade=0
                                    this.addCascade2=0
                                    items.children=[]
                                    this.OptionChildren=[]
                                    this.OptionChildren2=[]
                                    this.optionValue.forEach(item=>{
                                        if(item.value===this.cascadeOptionSelect1)
                                            item.children=[]
                                    })
                                }
                            }

                        })
                    }

                })
                /*for (let i =0 ;i<this.optionValue.length;i++)
                {
                    for (let j =0 ;j<this.optionValue[i].children.length;j++)
                    {
                        if(this.optionValue[i].children[j].length > 0)
                        {

                        }
                        else {
                            this.optionValue[i].children=[]
                            this.OptionChildren=[]
                        }

                    }
                }*/



            },
            delCascadeOption3(){
                this.optionValue.forEach(item=>{
                    if( item.children!==undefined)
                    {
                        item.children.forEach(items=>{
                            if(items.children!==undefined)
                            {
                                items.children=[]
                                this.OptionChildren2=[]
                                this.cascadeOptionSelect3=''
                                this.addCascade2=0
                            }

                        })
                    }

                })
                /*  for (let i =0 ;i<this.optionValue.length;i++)
                  {
                      for (let j =0 ;j<this.optionValue[i].children.length;j++)
                      {
                          this.optionValue[i].children=[j].children=[]


                      }
                  }*/


            },
            inputShow1(){
                this.showInput1=1
            },
            inputShow2(){
                if(this.cascadeOptionSelect1!=='')
                {
                    this.showInput2=1
                }
                else
                    this.$message.error('请先选择下拉值')
            },
            inputShow3(){
                if(this.cascadeOptionSelect2!=='')
                {
                    this.showInput3=1
                }
                else
                    this.$message('请先选择下拉值')
            },
            cacleInput1(){
                this.showInput1=0
                this.rivese1=''

                /* this.showInput=2*/
            },
            cacleRivese1(){
                this.showInput1=0
                this.rivese1=''
            },
            cacleRivese2(){
                this.showInput2=0
                this.rivese2=''
            },
            cacleRivese3(){
                this.showInput3=0
                this.rivese3=''
            },
            cacleInput2(){
                this.showInput2=0

                /* this.showInput=2*/
            },
            cacleInput3(){
                this.showInput3=0
                /* this.showInput=2*/
            },
            addCascadePullDown(){
                if(this.addCascade1===0)
                {
                    this.addCascade1=1
                }
                if(this.optionValue.length < 1)
                {
                    this.$message.error('请添加选项')
                }
                else
                {
                    if(this.addCascade2===3)
                    {
                        this.$message.error('只能添加三级下拉哦')
                    }
                    else
                    {
                        if(this.addCascade1===1&&this.addCascade!==2&& this.addCascade2!==3)
                        {
                            if(this.cascadeOptionSelect1!=='')
                            {
                                this.addCascade=2

                            }
                            else {
                                this.$message.error('请选择下拉')

                            }
                        }
                        else if(this.addCascade1===1&&this.addCascade===2&& this.addCascade2!==3)
                        {
                            if(this.cascadeOptionSelect2!=='')
                            {
                                this.addCascade2=3
                                this.cascadeOptionSelect3=''
                            }
                            else {
                                this.$message.error('请选择下拉')
                            }
                        }


                    }


                }



            },
            unique() {
                const res = new Map();
                return this.OptionChildren.filter((item) => !res.has(item.value) && res.set(item.value, 1));
            },
            unique2() {
                const res = new Map();
                return this.OptionChildren2.filter((item) => !res.has(item.value) && res.set(item.value, 1));
            },
            selectOption(value){
                this.optionValue.forEach(item=>{
                    if(item.value===value)
                    {
                        if(item.children!==undefined)
                        {
                            if(item.children.length > 0)
                            {
                                this.addCascade=2
                                this.OptionChildren=item.children
                            }
                            else
                                this.OptionChildren=[]
                        }
                        else
                        {
                            this.OptionChildren=[]
                        }
                    }

                })
                this.cascadeOptionSelect2=''
                this.cascadeOptionSelect3=''
               /* this.cascadeOptionChildren=[]
                this.optionValue.forEach(item=>{
                    if(item.value===value)
                    {
                        if(item.children.length < 1)
                        {
                            this.OptionChildren=[]
                        }
                        else {
                            this.OptionChildren=item.children
                        }
                        this.cascadeOptionChildren=item.value
                    }

                })*/

                console.log(value)
            },
            selectOption2(value){
                console.log(value)
                this.optionValue.forEach(item=>{
                    item.children.forEach(items=>{
                        if(items.value===value)
                        {
                            if(items.children!==undefined)
                            {
                                if(items.children.length > 0)
                                {
                                    console.log(items)
                                    this.addCascade2=3
                                    this.OptionChildren2=items.children


                                }
                                else
                                    this.OptionChildren2=[]
                            }
                            else {
                                this.OptionChildren2=[]
                            }


                        }


                    })
                })
                this.cascadeOptionSelect3=''

            },
            deleteOption(){

               /* if( this.fristOption===0)
                {
                    this.optionValue=[]

                }
                if(this.secondOption===0)
                {
                    this.OptionChildren=[]
                    this.optionValue.forEach(item=>{
                        item.children=[]
                    })
                }*/
               /* if(this.deleteOption1===2){
                    for (let i =0;i<this.optionValue.length;i++)
                    {
                        if(this.optionValue[i].value === this.fristName)
                        {
                            this.num2=i
                            this.optionValue.splice(i,1)

                            this.optionName2=''
                        }
                    }
                    this.OptionChildren=[]
                    this.cascadeOptionSelect1=''
                    this.cascadeOptionSelect2=''
                }
                if(this.deleteOption2===2){
                    for (let i =0;i<this.optionValue.length;i++)
                    {
                        if(this.optionValue[i].children.length!==0)
                        {
                            for (let j =0 ;j <this.optionValue[i].children.length ;j++)
                            {
                                if(this.optionValue[i].children[j].value===this.secondName)
                                {
                                    this.num2=j

                                    this.optionValue[i].children[j].children=[]
                                    this.OptionChildren2=[]
                                    this.cascadeOptionSelect3=''
                                    this.optionName3=''


                                }
                            }
                        }


                    }
                }*/
                if(this.deleteOption1===2){
                    console.log(this.optionValue)
                    console.log(this.fristName)
                    this.optionValue.forEach(item=>{
                        if(item.value===this.fristName)
                        {
                            this.optionValue.splice(this.deleteOptionIndex,1)
                            this.OptionChildren=[]
                            this.OptionChildren2=[]
                            this.cascadeOptionSelect1=''
                            this.cascadeOptionSelect2=''
                            this.cascadeOptionSelect3=''


                        }

                    })
                    /*  for (let i =0;i<this.optionValue.length;i++)
                      {
                          if(this.optionValue[i].value === this.fristName)
                          {
                              this.num2=i
                              this.optionValue.splice(i,1)
                              this.OptionChildren=[]
                              this.cascadeOptionSelect2=''
                              this.cascadeOptionSelect1=''
                              this.optionName2=''
                          }
                      }*/
                    this.deleteOption1=0


                    console.log(this.optionValue)
                    console.log(this.OptionChildren)
                }
                if(this.deleteOption2===2){
                    this.optionValue.forEach(item=>{
                        console.log(this.cascadeOptionSelect1)
                        if(item.value===this.cascadeOptionSelect1)
                        {
                            item.children.forEach(items=>{
                                items.children.splice(this.deleteOption2Index,1)
                                this.OptionChildren.splice(this.deleteOption2Index,1)
                                this.OptionChildren2=[]
                                this.cascadeOptionSelect2=''
                                this.cascadeOptionSelect3=''
                            })

                            /* item.children.forEach((items,index)=>{
                                 if(items.value===this.secondName)
                                 {
                                     items.children=[]
                                     this.OptionChildren2=[]
                                     console.log(items)

                                 }

                                 console.log(items,index)
                             })*/
                            /*item.children.children.splice(0,1)
                            this.OptionChildren2=[]*/
                            console.log(item)
                            /*  item.children.forEach()
                              item.children.splice(this.deleteOption2Index,1)*/
                        }
                    })

                    if(this.cascadeOptionSelect2===this.secondName)
                    {
                        this.cascadeOptionSelect3=''
                    }

                    this.deleteOption2=0
                }
                this.dialogFormVisibleDelete=false

            },
            reviseField(id,fieldDetail){
                this.fieldId=id
                console.log(this.fieldId)
                console.log(fieldDetail)
                this.optionValue=[]
                this.OptionChildren2=[]
                this.OptionChildren=[]
                this.showInput1=0
                this.showInput2=0
                this.showInput3=0
                if(fieldDetail.type==='INPUT'){
                    this.show=0
                    this.radio='2'
                    this.fieldType="单行文本"
                }
                if(fieldDetail.type==='TEXTAREA'){
                    this.show=1
                    this.radio='2'
                    this.fieldType="多行文本"
                }
                if(fieldDetail.type==='DATE_PICKER'){
                    this.show=2
                    this.radio='1'
                    this.fieldType="日期选择"
                }
                if(fieldDetail.type==='TIME_PICKER'){
                    this.show=3
                    this.radio='1'
                    this.fieldType="时间选择"
                }
                if(fieldDetail.type==='SELECT'){
                    this.show=4;
                    this.radio='1'
                    this.fieldType="下拉列表"

                }
                if(fieldDetail.type==='RADIO'){
                    this.show=5
                    this.radio='1'
                    this.fieldType="单选框"
                    this.radioFiledOptions=fieldDetail.extInfo.exinfo
                }
                if(fieldDetail.type==='CHECKBOX'){
                    this.show=6
                    this.radio='1'
                    this.fieldType="复选框"
                    this.checkBoxFiledOptions=fieldDetail.extInfo.exinfo
                }
                if(fieldDetail.type==='CASCADER'){
                    this.show=7
                    this.radio='1'
                    this.fieldType="级联选择"
                    if(fieldDetail.extInfo.cascadeDown[0].options.length > 0)
                    {
                        this.addCascade1=1
                        this.addCascade2=1
                        this.addCascade=1
                        fieldDetail.extInfo.cascadeDown[0].options.forEach(item=>{
                            this.optionValue.push(item)

                        })
                    }


                }
                if(fieldDetail.type==='DATETIME_RANGE'){
                    this.show=8
                    this.radio='1'
                    this.fieldType="选择日期时间范围"
                }

                fieldDetail.extInfo.cascadeDown[0].options.forEach((item)=>{
                    if(item.value!=='')
                    {

                        if(item.children!==undefined)
                        {
                            this.addCascade=2
                            if(item.children.length  > 0)
                            {
                                this.cascadeOptionSelect1=item.value
                                this.OptionChildren=item.children
                                this.cascadeOptionSelect2=item.children[0].value
                                item.children.forEach(items=>{
                                    if(items.children!==undefined)
                                    {
                                        this.addCascade2=3
                                    }
                                })
                                if(item.children[0].children!==undefined)
                                {

                                    if(item.children[0].children.length > 0)
                                    {

                                        this.cascadeOptionSelect3=item.children[0].children[0].value
                                        this.OptionChildren2=item.children[0].children
                                    }
                                    else
                                        this.cascadeOptionSelect3=''
                                }


                                /* item.children.forEach(items=>{
                                     if(items.children.length > 0)
                                     {


                                     }



                                 })*/
                                /*if(item.children[0].value!==undefined)
                                {

                                    this.cascadeOptionSelect2=item.children[0].value
                                    if(item.children[0].children[0].value!==undefined)
                                    {
                                        this.OptionChildren2=item.children[0].children
                                        this.cascadeOptionSelect3=item.children[0].children[0].value
                                    }
                                }
                               */

                            }
                            else
                                this.cascadeOptionSelect2=''
                        }

                    }

                })
                this.dialogFormVisible1=true
                this.filedName=fieldDetail.name
                this.filedDescription=fieldDetail.description

                    if(fieldDetail.extInfo.length!==0){
                        fieldDetail.extInfo.exinfo.filter(item=>{
                            if(item.value!==" ")
                            {
                                this.radioOptions=fieldDetail.extInfo.exinfo
                            }

                            console.log(this.radioOptions)
                        })
                    }


            },
            deleteOpenDialog(id){
                this.fieldId=id
                this.dialogFormVisible=true
            },
            radioChange(index){
                for (let i =0;i<this.radioOptions.length;i++)
                {
                    this.radioOptions[i]._default='true'
                }
                this.radioOptions[index]._default='false'
            },
            resortOptionSet(){
                let _this = this;
                let el = document.getElementById('radioOption');
                let el2=document.getElementById('radioOption2')
                let el3=document.getElementById('radioOption3')

                new Sortable(el,{
                    ghostClass: 'blue-background-class',
                    animation: 200,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el.children[newIndex],
                            $oldLi = el.children[oldIndex];
                        // 先删除移动的节点
                        el.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el.insertBefore($li,$oldLi)
                        } else {
                            el.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.radioOptions.splice(oldIndex,1)
                        _this.radioOptions.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },
                });
                new Sortable(el2,{
                    ghostClass: 'blue-background-class',
                    animation: 200,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el2.children[newIndex],
                            $oldLi = el2.children[oldIndex];
                        // 先删除移动的节点
                        el2.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el2.insertBefore($li,$oldLi)
                        } else {
                            el2.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.radioOptions.splice(oldIndex,1)
                        _this.radioOptions.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },
                });
                new Sortable(el3,{
                    ghostClass: 'blue-background-class',
                    animation: 200,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el3.children[newIndex],
                            $oldLi = el3.children[oldIndex];
                        // 先删除移动的节点
                        el3.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el3.insertBefore($li,$oldLi)
                        } else {
                            el3.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.radioOptions.splice(oldIndex,1)
                        _this.radioOptions.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },
                });
                this.radioOptions=_this.radioOptions
                console.log(this.radioOptions)
            },
            deleteAllOption(){
                if( this.fristOption===0)
                {
                    this.optionValue=[]
                    this.OptionChildren2=[]
                    this.OptionChildren=[]
                    this.fristOption=1
                    this.cascadeOptionSelect1=''
                    this.fristOption=1
                    this.addCascade2=0
                    this.addCascade=0

                }
                if(this.secondOption===0)
                {
                    this.OptionChildren=[]
                    this.OptionChildren2=[]
                    this.optionValue.forEach(item=>{
                        item.children=[]
                        this.secondOption=1
                        this.cascadeOptionSelect2=''
                        this.addCascade2=0
                        this.addCascade=0
                    })

                }
                this.dialogFormVisibleDelete2=false
            },
            indexMethod(index){
                return index+1
            }


        }
    }
</script>

<style  lang="less">
@import "../../../assets/less/fieldmanagement/fieldinfo/fieldinfo";
.module-result-content-field {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    .result-content-field {
        flex: 1;
        position: relative;
        .el-table {

            position: absolute;
            overflow: hidden;

        }
    }
}
    .fieldRowClass{
        font-family: "Arial Normal", "Arial", sans-serif;
        height: 60px;
        line-height: 60px;
    }
</style>